import * as React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useParams} from 'react-router-dom';
import {AppState} from "../store";
import {useTranslation} from 'react-i18next';
import {getStatus, setStatus} from "../store/reduxProperties/general/actions";
import {MainSpinner} from "mig-spinner";
import {Card, CardBody} from 'reactstrap';

export const StatusDetail = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { key } = useParams();
    const { isLoadingStatus, status } = useSelector((state: AppState) => state.generalStore);

    React.useEffect(() => {
        dispatch(setStatus(null));
        if (key) {
            dispatch(getStatus(key));
        }
    }, [dispatch, key]);

    return (
        <>
            <MainSpinner message={t('isLoadingStatus')} loading={isLoadingStatus} />
            { status && !isLoadingStatus &&
            <Card className={"mt-3 border-0"}>
                <CardBody>
                    <h2>{t('title')}</h2>
                    <p className={"mb-3"}>{t('lmaBeskrivning')}</p>
                    <h3 className={"mb-3"}>{t('giltighet.header')}</h3>
                    <span className={status.omfattasAvLma ? "positive p-2" : "negative p-2"}>
                        <i className={status.omfattasAvLma ? "fa fa-check-circle text-success mr-2" : "fa fa-times-circle text-danger mr-2"} />
                        <span className="font-weight-bold">{t('giltighet.kortetAr')} </span>
                        <span className="font-italic">{status.omfattasAvLma ? t('giltighet.giltigt') : t('giltighet.inteGiltigt')}</span>
                    </span>
                    <p className={"mt-3"}>{t('giltighet.body')}</p>
                    <h3 className={"mb-3"}>{t('atUnd.header')}</h3>
                    <span className={status.hasArbetstillstand ? "positive p-2" : "negative p-2"}>
                        <i className={status.hasArbetstillstand ? "fa fa-check-circle text-success mr-2" : "fa fa-times-circle text-danger mr-2"} />
                        <span className="font-weight-bold">{t('atUnd.atUnd')} </span>
                        <span className="font-italic">{status.hasArbetstillstand ? t('atUnd.finns') : t('atUnd.saknas')}</span>
                    </span>
                    <p className={"mt-3"}>{t('atUnd.body')}</p>
                    <h3 className={"mt-3"}>{t('infoTillArbetsgivare.header')}</h3>
                    <p className={"mb-2"}>{t('infoTillArbetsgivare.body1')}</p>
                    <div className="d-inline-flex flex-column mb-2">
                        <a target="_blank" rel="noopener noreferrer" href={"https://www.migrationsverket.se/arbetsgivare/du-vill-anstalla/anstalla-fran-lander-utanfor-eu-ees/anstalla-nagon-som-redan-ar-i-sverige/asylsokande.html"}>{t('infoTillArbetsgivare.lasMer')}</a>
                        <a target="_blank" rel="noopener noreferrer" href={"https://www.migrationsverket.se/kontakta-oss/skicka-dokument-till-oss.html"}>{t('infoTillArbetsgivare.hittaEnhet')}</a>
                    </div>
                    <p>{t('infoTillArbetsgivare.body2')}</p>
                    <p><strong>{t('footer')} <a target="_blank" rel="noopener noreferrer" href={"https://www.migrationsverket.se/"}>{t('homepage')}</a> {t('telefonnummer')}</strong></p>
                </CardBody>
            </Card>
            }
        </>
    )
}
